module.exports = __webpack_public_path__ + "static/media/expand-alt.79ec0cdc.svg";